import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo1/mariolava.png";
import Imagen2 from "../../../images/modulo1/futbol.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo1 } from "../../../routes/Module1";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import InputRadioButton from "../../../components/InputRadioButton";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo1/Actividad5.mp3";

const Actividad5 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "option3" },
    ans2: { value: "", valid: "", correctValue: "option2" },
  });
  const infoUnidad = modulo1.content[0];
  const infoAct = modulo1.content[0].activities[4];
  const crumbs = [
    {
      title: modulo1.title,
      url: "/" + modulo1.url,
    },
    {
      title:
        modulo1.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo1.content[0].activities[5].name}`,
    linkNext: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[5].path}`,
    titlePrev: `${modulo1.content[0].activities[3].name}`,
    linkPrev: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[3].path}`,
  };
  const metadata = {
    color: modulo1.color,
    title: `${modulo1.title} - ${infoAct.name}`,
    name: modulo1.title
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswer = (label, value) => {
    setAnswers({
      ...answers,
      [label]: { ...answers[label], value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo1.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 5</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          A veces no nos gusta cumplir con algunas obligaciones familiares.
        </li>
        <li>
          Observa las imágenes y conversa con un compañero, compañera o
          familiar. ¿Por qué creen que están molestos Mario y Sara?
        </li>
        <li>Selecciona la opción correcta.</li>
      </ul>
      <div className="row mt-5 align-items-center">
        <div className="col-md-5 col-xs-12">
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-6 col-xs-12 offset-md-1 offset-xs-0">
          <Card>
            <p>Mario está molesto porque…</p>
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option1"
              text="no le gusta el agua fría."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option2"
              text="le duele la cabeza."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans1}
              label="ans1"
              value="option3"
              text="preferiría estar viendo televisión."
              handleAnswer={handleAnswer}
            />
          </Card>
        </div>
      </div>
      <div className="row mt-4 align-items-center">
        <div className="col-md-5 col-xs-12">
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-6 col-xs-12 offset-md-1 offset-xs-0">
          <Card>
            <p>Sara está molesta porque…</p>
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option1"
              text="está cansada."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option2"
              text="quiere seguir jugando fútbol."
              handleAnswer={handleAnswer}
            />
            <InputRadioButton
              ans={answers.ans2}
              label="ans2"
              value="option3"
              text="ha discutido con una amiga."
              handleAnswer={handleAnswer}
            />
          </Card>
        </div>
      </div>
      <div className="row my-4">
        <div className="col-md-12">
          <button
            className={`btn float-end btn-${modulo1.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>
      <ul className="mt-5">
        <li>
          Ahora cuéntale a un compañero, compañera o familiar qué obligación te
          cuesta cumplir en el hogar.
        </li>
      </ul>
      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las escenas una por una y lea el texto
          correspondiente. Dialoguen sobre las opciones de respuesta escogidas.
          Enfatice la importancia de cumplir con nuestras obligaciones, aunque
          no nos gusten mucho.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
